<template>
  <div
    v-if="images.length"
    class="alt-img"
    :for="`image-radio-${index}`"
  >
    <div
      v-if="data.video"
      class="video"
    >
      <div class="layer" />
      <div class="product-video-wrapper">
        <span class="play-control" />
      </div>
      <Picture
        :image-url="images[0].path"
        :alt="seoAlt"
        :image-sizes-by-breakpoints="imageSizesByBreakpoints"
        lazy-load
      />
    </div>
    <template v-else>
      <Picture
        :image-url="data.path"
        :alt="seoAlt"
        :image-sizes-by-breakpoints="imageSizesByBreakpoints"
        lazy-load
      />
    </template>
    <div
      class="border"
      :class="{ invisible: currentPage - 1 !== index }"
    />
  </div>
</template>

<script setup>
import Picture from '@components/common/Media/Picture';

const imageSizesByBreakpoints = {
  small: 44,
  medium: 60,
  large: 44,
  mlarge: 82,
  xlarge: 82,
};

defineProps({
  // eslint-disable-line no-undef
  data: {
    /** @type import('vue').PropType<Image> */
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    default: 0,
  },
  images: {
    /** @type import('vue').PropType<Array<Image>> */
    type: Array,
    default: () => [],
  },
  videoId: {
    type: String,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
  },
  seoAlt: {
    type: String,
    default: '',
  },
});
</script>

<style lang="scss" scoped>
  @import "@csgIcons/_play-control.scss";

  .alt-img {
    display: block;
    width: rem-calc(82);
    height: rem-calc(102);
    max-height: rem-calc(102);
    position: relative;
    cursor: pointer;
    @include breakpoint(medium only) {
      min-width: 100%;
      width: 100%;
      height: rem-calc(75);
    }
    @include breakpoint(large down) {
      width: rem-calc(44);
      height: rem-calc(55);
      max-height: rem-calc(55);
    }
    .video {
      width: 100%;
      height: 100%;
      .layer {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 9;
        background-color: rgba(255, 255, 255, 0.4);
      }
      .product-video-wrapper {
        width: rem-calc(24);
        height: rem-calc(24);
        border-radius: 50%;
        position: absolute;
        z-index: 10;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
        .play-control {
          width: rem-calc(24);
          height: rem-calc(24);
          background-size: rem-calc(24) rem-calc(24);
        }
      }
    }

    .border {
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border: 2px solid $black;
      top: 0;
      left: 0;
      z-index: 10;
    }
  }
</style>
